module.exports = __webpack_public_path__ + "static/img/paihangbang.5c4e665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/category/paihangbang.jpg
// module id = xGvh
// module chunks = 0